'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Month = Month;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponentsReactiveGrid = require('styled-components-reactive-grid');

var _Calendar = require('../../../blocks/Calendar');

var _Calendar2 = _interopRequireDefault(_Calendar);

var _QuickActionButton = require('../../../blocks/QuickActionButton');

var _QuickActionButton2 = _interopRequireDefault(_QuickActionButton);

var _P = require('../../../elements/P');

var _P2 = _interopRequireDefault(_P);

var _DateGrid = require('../DateGrid');

var _DateGrid2 = _interopRequireDefault(_DateGrid);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// TODO: Determine a way to implement translations
var MONTHS = {
  1: 'January',
  2: 'February',
  3: 'March',
  4: 'April',
  5: 'May',
  6: 'June',
  7: 'July',
  8: 'August',
  9: 'September',
  10: 'October',
  11: 'November',
  12: 'December'
};

/**
 * Renders a month of the Calendar component.
 */
function Month(_ref) {
  var disabledDates = _ref.disabledDates,
      displayMonth = _ref.displayMonth,
      hoveredOverDate = _ref.hoveredOverDate,
      onClickNext = _ref.onClickNext,
      onClickPrevious = _ref.onClickPrevious,
      onSelectDate = _ref.onSelectDate,
      range = _ref.range,
      selectedDate = _ref.selectedDate,
      selectedDateRange = _ref.selectedDateRange,
      today = _ref.today,
      updateHoveredOverDate = _ref.updateHoveredOverDate,
      displayPreviousNav = _ref.displayPreviousNav,
      displayNextNav = _ref.displayNextNav;

  return _react2.default.createElement(
    _styledComponentsReactiveGrid.Column,
    { modifiers: ['col', 'fluid'] },
    _react2.default.createElement(
      _Calendar2.default,
      null,
      _react2.default.createElement(
        _styledComponentsReactiveGrid.Row,
        { modifiers: ['middle'] },
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_2'] },
          displayPreviousNav && _react2.default.createElement(
            _QuickActionButton2.default,
            {
              className: 'previous-month-nav',
              modifiers: ['iconOnly'],
              onClick: onClickPrevious,
              type: 'button'
            },
            _react2.default.createElement(_QuickActionButton2.default.Icon, {
              name: 'chevron-left',
              modifiers: ['mini']
            })
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['center', 'col', 'padScaleY_4'] },
          _react2.default.createElement(
            _P2.default,
            null,
            MONTHS[displayMonth.month] + ' ' + displayMonth.year
          )
        ),
        _react2.default.createElement(
          _styledComponentsReactiveGrid.Column,
          { modifiers: ['col_2', 'end'] },
          displayNextNav && _react2.default.createElement(
            _QuickActionButton2.default,
            {
              className: 'next-month-nav',
              modifiers: ['iconOnly'],
              onClick: onClickNext,
              type: 'button'
            },
            _react2.default.createElement(_QuickActionButton2.default.Icon, {
              name: 'chevron-right',
              modifiers: ['mini']
            })
          )
        )
      ),
      _react2.default.createElement(_DateGrid2.default, {
        disabledDates: disabledDates,
        displayMonth: displayMonth,
        hoveredOverDate: hoveredOverDate,
        onSelectDate: onSelectDate,
        range: range,
        selectedDate: selectedDate,
        selectedDateRange: selectedDateRange,
        today: today,
        updateHoveredOverDate: updateHoveredOverDate
      })
    )
  );
}

Month.propTypes = {
  disabledDates: _propTypes2.default.shape({
    after: _propTypes2.default.instanceOf(Date),
    before: _propTypes2.default.instanceOf(Date)
  }),
  displayMonth: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    daysInMonth: _propTypes2.default.number.isRequired
  }).isRequired,
  displayNextNav: _propTypes2.default.bool.isRequired,
  displayPreviousNav: _propTypes2.default.bool.isRequired,
  hoveredOverDate: _propTypes2.default.instanceOf(Date),
  onClickNext: _propTypes2.default.func.isRequired,
  onClickPrevious: _propTypes2.default.func.isRequired,
  onSelectDate: _propTypes2.default.func.isRequired,
  range: _propTypes2.default.bool,
  selectedDate: _propTypes2.default.instanceOf(Date),
  selectedDateRange: _propTypes2.default.shape({
    from: _propTypes2.default.instanceOf(Date),
    to: _propTypes2.default.instanceOf(Date)
  }),
  today: _propTypes2.default.shape({
    year: _propTypes2.default.number.isRequired,
    month: _propTypes2.default.number.isRequired,
    date: _propTypes2.default.number.isRequired
  }).isRequired,
  updateHoveredOverDate: _propTypes2.default.func.isRequired
};

Month.defaultProps = {
  disabledDates: {},
  hoveredOverDate: null,
  range: false,
  selectedDate: null,
  selectedDateRange: {}
};

exports.default = Month;


//////////////////
// WEBPACK FOOTER
// ./node_modules/base-components/build/components/DateSelectors/Calendars/Month.js
// module id = 1633
// module chunks = 2